module.exports = __webpack_public_path__ + "static/media/device_actions_green.f41cbc11.png";